import React from 'react';
import { FiLoader } from 'react-icons/fi';

/**
 * Shared chart chrome: fixed-height box (Highcharts needs a real height),
 * aria label, and the three overlays (empty / loading / error). Chart
 * components render their HighchartsReact as children.
 */
const ChartFrame = ({
    ariaLabel, height, width, loading = false, error = null, empty = false,
    emptyMessage, errorMessage, retryLabel, onRetry, children,
}) => (
    <div role="img" aria-label={ariaLabel} aria-busy={loading ? 'true' : undefined}
         className={width ? "relative shrink-0" : "relative w-full"} style={{ height, width }}>
        {children}
        {empty && !loading && !error && emptyMessage ? (
            <div role="status" aria-live="polite"
                 className="absolute inset-0 flex items-center justify-center px-4 text-center text-sm text-slate-500 dark:text-slate-400">
                {emptyMessage}
            </div>
        ) : null}
        {error ? (
            <div role="alert"
                 className="absolute inset-0 flex flex-col items-center justify-center gap-2 px-4 text-center text-sm text-slate-600 dark:text-slate-300 bg-white/70 dark:bg-slate-800/70">
                <span>{errorMessage}</span>
                {onRetry ? (
                    <button type="button" onClick={onRetry}
                            className="rounded-md border border-slate-300 dark:border-slate-600 px-3 py-1 text-xs font-medium hover:bg-slate-100 dark:hover:bg-slate-700">
                        {retryLabel}
                    </button>
                ) : null}
            </div>
        ) : null}
        {loading ? (
            <div aria-live="polite"
                 className="absolute inset-0 flex items-center justify-center bg-white/50 dark:bg-slate-800/50 backdrop-blur-[1px]">
                <FiLoader className="w-6 h-6 animate-spin text-slate-500 dark:text-slate-400" />
            </div>
        ) : null}
    </div>
);

export default ChartFrame;
